<template>
  <div class="button flex ai-center" :class="name" @click="openLink">
      <i class="fab " :class="'fa-'+name" v-if="name != 'website'"></i>
      <i class="fas fa-window-maximize" v-else></i>
      <h1>{{ name }}</h1>
  </div>
</template>

<script>
export default {
    name: 'LinkButton',
    props: [
        'name',
        'link'
    ],
    methods: {
        openLink() {
            window.open(this.link, '_blank');
        }
    }
}
</script>

<style scoped>

.button {
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.2);
    border: 2px solid;
    border-radius: 5px;
    box-sizing: initial;
    padding-block: 5px;
    position: relative;
    text-align: center;
    transition: all .3s ease;
    cursor: pointer;
}

.button i {
    font-size: 35px;
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    transition: all .3s ease;
}

.button h1 {
    width: 100%;
    text-align: center;
    color: #fe0000;
    font-family: 'Poppins' , sans-serif;
    text-transform: uppercase;
    font-size: 25px;
    transition: all .3s ease;
    z-index: 1;
    position: relative;
    letter-spacing: 1px;
    font-weight: 500;
}

.button::before {
    content: '';
    width: 0%;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    transition: all .4s ease;
}

.button:hover::before {
    width: 100%;
}

.button:hover h1 , .button:hover i {
    color: white;
}

.instagram {
    border-color: white;
}

.instagram i , .instagram h1 {
    color: white;
}

.instagram::before {
    background-color: black;
}

.youtube {
    border-color: #fe0000;
}

.youtube i {
    color: #fe0000;
}

.youtube::before {
    background-color: #fe0000;
}

.twitch {
    border-color: #9147ff;
}

.twitch i , .twitch h1 {
    color: #9147ff;
}

.twitch::before {
    background-color: #9147ff;
}

.twitter {
    border-color: #1da1f3;
}

.twitter i , .twitter h1 {
    color: #1da1f3;
}

.twitter::before {
    background-color: #1da1f3;
}

.website {
    border-color: white;
}

.website i , .website h1 {
    color: white;
}

.website::before {
    background-color: black;
}

</style>